// extracted by mini-css-extract-plugin
module.exports = {"title":"e_KG","icon":"e_LG"};